import React from 'react';
import { makeStyles } from '@mui/styles';

// Create styles using makeStyles
const useStyles = makeStyles({
    gridContainer: {
        display: 'grid',
        overflowY: 'scroll',
        height: '90vh',
        gridTemplateColumns: 'repeat(3, 1fr)', // 3 columns
        gap: '15px', // Gap between grid items
        padding: '20px',
    },
    gridItem: {
        cursor: 'pointer',
    },
    gridItemImg: {
        width: '100%',
        height: 'auto',
        border: '2px solid #ccc',
        borderRadius: '8px',
        transition: 'transform 0.2s',
        '&:hover': {
            transform: 'scale(1.05)',
        },
    },
});

const UserEditAvatar = ({ onBack }) => {
    const classes = useStyles();

    const submitAvatar = async (avatar) => {
        try {
            const token = localStorage.getItem('token') || '';
            const userId = localStorage.getItem('userId');

            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `${token}` : '',
            };

            const response = await fetch(`https://beiguru.co.in/api/employees/${userId}/${avatar}`, {
                method: 'PUT',
                headers: headers,
            });

            if (response.status === 200) {
                localStorage.setItem('avatar', avatar);
                onBack(true);
            } else {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
        } catch (error) {
            console.error('Error submitting avatar:', error);
        }
    };

    const images = Array.from({ length: 15 }, (_, i) => require(`../assets/a${i + 1}.png`));

    return (
        <div className={classes.gridContainer}>
            {images.map((src, index) => (
                <div key={index} className={classes.gridItem} onClick={() => submitAvatar(index + 1)}>
                    <img src={src} alt={`Avatar ${index + 1}`} className={classes.gridItemImg} />
                </div>
            ))}
        </div>
    );
}

export default UserEditAvatar;